import { Modal, Form, Input } from "antd";
import TextArea from "antd/es/input/TextArea";
import { changeLoader } from "../../redux/reducers/loader";
import * as Validation from "../../utils/helper/validation";
import * as Apis from "../../utils/helper/enum";
import { useDispatch } from "react-redux";
import globalRequest from "../../utils/global/globalRequest";
import toast from "react-hot-toast";
import { useEffect, useState } from "react";
import { amountValidation } from "../../utils/helper/utils";

const CancelOrder = ({ isOpen, onOk, onCancel, ReasonText, orderDetailData }) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [formData, setFormData] = useState({
    reason: "",
    reasonErr: "",
    customer_amt: 0,
    customer_amtErr: "",
    vendor_amt: 0,
    vendor_amtErr: "",
    pickup_vendor_amt: 0,
    pickup_vendor_amtErr: "",
  });
  const [vendorDetail, setVendorDetail] = useState({});
  const [pickupVendorDetail, setpickupVendorDetail] = useState({});

  useEffect(() => {
    for (let order of orderDetailData.orderDetails) {
      if (order.vendorId === orderDetailData.vendorId) setVendorDetail(order.vendorDetails.vendorDetail);
      if (orderDetailData.pickupVendorId && orderDetailData.pickupVendorId > 0 && orderDetailData.pickupVendorId === order.vendorId)
        setpickupVendorDetail(order.vendorDetails.vendorDetail);
    }
  }, [orderDetailData]);

  const handleSubmit = async (values) => {
    let {
      cancel_reason: reason,
      customer_amt,
      vendor_amt,
      pickup_vendor_amt,
    } = values;
    let token = false;
    if (reason === "") {
      token = true;
      setFormData((prev) => ({
        ...prev,
        reasonErr: "Reason is required.",
      }));
    }
    if (orderDetailData.status !== "placed" && orderDetailData.orderDeliveryType !== "qc") {
      if (!formData.customer_amt && !formData.vendor_amt && formData.customer_amt < 1 && formData.vendor_amt < 1) {
        token = true;
        setFormData((prev) => ({
          ...prev,
          customer_amtErr: "Amount is required.",
        }));
      }

      if (formData.vendor_amt && isNaN(Number(formData.vendor_amt))) {
        token = true;
        setFormData((prev) => ({
          ...prev,
          vendor_amtErr: "Invalid amount.",
        }));
      }

      if (formData.pickup_vendor_amt && isNaN(Number(formData.pickup_vendor_amt))) {
        token = true;
        setFormData((prev) => ({
          ...prev,
          pickup_vendor_amtErr: "Invalid amount.",
        }));
      }

      let amount = parseInt(formData.customer_amt); // + parseInt(formData.vendor_amt);
      if (formData.vendor_amt && formData.vendor_amt !== "") amount = amount + parseInt(formData.vendor_amt);
      if (formData.pickup_vendor_amt && formData.pickup_vendor_amt !== "") amount = amount + parseInt(formData.pickup_vendor_amt);
      if (amount > orderDetailData.totalAmount) {
        token = true;
        toast.error("The amount entered cannot exceed the total order amount.");
      }
    }

    if (token) {
      return token;
    }

    const insertData = {
      status: "cancelled",
      reason: reason,
      amount: customer_amt || 0,
      vendor_amount: vendor_amt || 0,
      pickup_vendor_amount: pickup_vendor_amt || 0,
    };

    dispatch(changeLoader(true));
    try {
      let url = Apis?.ORDERS?.CANCEL_ORDER + "/" + orderDetailData.id;
      let method = "post";
      let response = await globalRequest(url, method, insertData, {}, true);
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let msg = "Order successfully cancelled.";
        toast.success(msg, {
          duration: 2000,
        });
      } else {
        toast.error(apiResponse?.message);
      }
      onOk();
    } catch (e) {
      toast.error(e?.message);
    }
    dispatch(changeLoader(false));
  };

  return (
    <>
      <Modal
        title={ReasonText}
        centered
        open={isOpen}
        onCancel={onCancel}
        onOk={() => {
          form.submit();
        }}
        width={440}
        okText="Submit"
        cancelText="Cancel"
      >
        <h2 className="text-sm font-normal mb-2">Please submit reason to cancel this order.</h2>
        <Form
          form={form}
          name="Cancel Order"
          layout="vertical"
          onFinish={handleSubmit}
          autoComplete="off"
          style={{
            maxWidth: 600,
            width: "100%",
          }}
          initialValues={
            {
              // remember: true,
            }
          }
        >
          <Form.Item
            name="cancel_reason"
            label="Cancellation Reason"
            labelCol={{
              style: {
                color: "#222222",
                fontWeight: "600",
                fontSize: "14px",
                paddingBottom: "5px",
              },
            }} // Custom label style
          >
            <TextArea
              rows={3}
              maxLength={100}
              onChange={(e) => {
                setFormData((prevData) => ({
                  ...prevData,
                  reason: e.target?.value?.trimStart(),
                  reasonErr: "",
                }));
              }}
            />
            {formData?.reasonErr && <span className="text-[#ff4d4f]">{formData?.reasonErr}</span>}
          </Form.Item>
          {orderDetailData.status !== "placed" && orderDetailData.orderDeliveryType !== "qc" ? (
            <>
              <Form.Item name="customer_amt" label="Refund amount to customer" rules={amountValidation()}>
                <Input
                  size="large"
                  suffix="SAR"
                  onChange={(e) => {
                    let value = Validation.strFormat(e.target.value);
                    setFormData((prevData) => ({
                      ...prevData,
                      customer_amt: value,
                      customer_amtErr: "",
                    }));
                  }}
                />
              </Form.Item>
              {orderDetailData.orderDeliveryType !== "delivery" && <Form.Item
                name="vendor_amt"
                label={`Payout to vendor (${vendorDetail.storeName})`} rules={amountValidation()}
              >
                <Input
                  size="large"
                  suffix="SAR"
                  onChange={(e) => {
                    let value = Validation.strFormat(e.target.value);
                    setFormData((prevData) => ({
                      ...prevData,
                      vendor_amt: value,
                      customer_amtErr: "",
                      vendor_amtErr: "",
                      pickup_vendor_amtErr: "",
                    }));
                  }}
                />
              </Form.Item>}
              {(orderDetailData.orderDeliveryType !== "delivery" && Object.keys(pickupVendorDetail).length > 0)  && (
                <Form.Item
                  name="pickup_vendor_amt"
                  label={`Payout to vendor (${pickupVendorDetail.storeName})`}
                  rules={amountValidation()}
                >
                  <Input
                    size="large"
                    suffix="SAR"
                    onChange={(e) => {
                      let value = Validation.strFormat(e.target.value);
                      setFormData((prevData) => ({
                        ...prevData,
                        pickup_vendor_amt: value,
                        customer_amtErr: "",
                        vendor_amtErr: "",
                        pickup_vendor_amtErr: "",
                      }));
                    }}
                  />
                </Form.Item>
              )}
            </>
          ) : null}
        </Form>
      </Modal>
    </>
  );
};
export default CancelOrder;
